import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NewDischargePopup from './NewDischargePopup';
import DischargeDetailPopup from './DischargeDetailPopup';
import { toast } from 'react-toastify';
import { FiEye, FiEdit2, FiTrash2, FiPrinter } from 'react-icons/fi';

export interface Discharge {
  id: number;
  name: string;
  date: string;
  descargo: string;
  testigo1: string;
  testigo2: string;
  estado: string;
  jefe: string;
  files: string;
}

const EmployeeDischargeList: React.FC = () => {
  const [descargos, setDescargos] = useState<Discharge[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedDischarge, setSelectedDischarge] = useState<Discharge | null>(null);

  useEffect(() => {
    fetchDescargos();
  }, []);

  const fetchDescargos = async () => {
    try {
      const response = await axios.get('http://localhost:3004/descargos');
      setDescargos(response.data);
    } catch (error) {
      console.error('Error fetching descargos:', error);
      toast.error('Error al obtener los descargos');
    }
  };

  const handleCreate = async (
    name: string,
    date: string,
    testigo1: string,
    testigo2: string,
    jefe: string,
    descargo: string,
    estado: string,
    pruebas: File
  ) => {
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('date', date);
      formData.append('testigo1', testigo1);
      formData.append('testigo2', testigo2);
      formData.append('jefe', jefe);
      formData.append('descargo', descargo);
      formData.append('estado', estado);
      formData.append('files', pruebas);

      await axios.post('http://localhost:3004/descargos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      toast.success('Descargo creado con éxito');
      fetchDescargos();
      setIsPopupOpen(false);
    } catch (error) {
      console.error('Error al crear el descargo:', error);
      toast.error('Hubo un error al crear el descargo');
    }
  };

  const openDetailPopup = (discharge: Discharge) => {
    setSelectedDischarge(discharge);
  };

  const handlePrintFile = (fileUrl: string) => {
    const newWindow = window.open(fileUrl, '_blank');
    if (newWindow) {
      newWindow.addEventListener('load', () => newWindow.print());
    } else {
      toast.error('No se pudo abrir el archivo para imprimir');
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await axios.delete(`http://localhost:3004/descargos/${id}`);
      setDescargos(descargos.filter((descargo) => descargo.id !== id));
      toast.success('Descargo eliminado con éxito');
    } catch (error) {
      console.error('Error deleting discharge:', error);
      toast.error('Error al eliminar el descargo');
    }
  };

  return (
    <div className="p-6">
      <button
        onClick={() => setIsPopupOpen(true)}
        className="mb-4 px-6 py-3 bg-blue-600 text-white rounded-lg text-lg font-semibold hover:bg-blue-700 transition duration-200"
      >
        Agregar Nuevo Descargo
      </button>

      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-gray-200 text-gray-700">
            <th className="py-2 px-4 border-b text-left">Id</th>
            <th className="py-2 px-4 border-b text-left">Fecha</th>
            <th className="py-2 px-4 border-b text-left">Nombre de Empleado</th>
            <th className="py-2 px-4 border-b text-left">Descripción</th>
            <th className="py-2 px-4 border-b text-left">Testigos</th>
            <th className="py-2 px-4 border-b text-left">Jefe</th>
            <th className="py-2 px-4 border-b text-left">Estado</th>
            <th className="py-2 px-4 border-b text-left">Acción</th>
          </tr>
        </thead>
        <tbody>
          {descargos.map((descargo) => (
            <tr key={descargo.id} className="border-b">
              <td className="py-2 px-4">{descargo.id}</td>
              <td className="py-2 px-4">{new Date(descargo.date).toLocaleDateString('es-ES')}</td>
              <td className="py-2 px-4">{descargo.name}</td>
              <td className="py-2 px-4">{descargo.descargo}</td>
              <td className="py-2 px-4">{descargo.testigo1} / {descargo.testigo2}</td>
              <td className="py-2 px-4">{descargo.jefe}</td>
              <td className="py-2 px-4">{descargo.estado}</td>
              <td className="py-2 px-4">
                <div className="flex gap-2">
                  <button
                    onClick={() => openDetailPopup(descargo)}
                    className="px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 transition duration-200"
                  >
                    <FiEye />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedDischarge(descargo);
                  
                    }}
                    className="px-2 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
                  >
                    <FiEdit2 />
                  </button>
                  
                  <button
                    onClick={() => handleDelete(descargo.id)}
                    className="px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600 transition duration-200"
                  >
                    <FiTrash2 />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedDischarge && (
        <DischargeDetailPopup
          discharge={selectedDischarge}
          onClose={() => setSelectedDischarge(null)}
        />
      )}

      {isPopupOpen && (
        <NewDischargePopup
          onClose={() => setIsPopupOpen(false)}
          onCreate={handleCreate}
        />
      )}
    </div>
  );
};

export default EmployeeDischargeList;
